<template>
<div>
  <div class="overlay">
    <div class="top-text">
      <div class="wip-text">Work In Progress!</div>
    </div>
    <div class="employee">
    <tl-header type="h3" class="title">
            Employees
    </tl-header>
    <div class="row">
        <div class="col-3">
            <tl-select
                placeholder="Select"
                :value="month"
                :options="months"
                @change="(val)=>{month=val}"
                :disabled='true'
            />
        </div>
        <div class="empDetails col-7">
            <span> Employee Joins: <b> {{employeeJoins}} </b> </span>
            <span> Employee Exits: <b> {{employeeExits}} </b> </span>
        </div>
    </div>
  </div>
</div>
</div>
</template>

<script>
export default {
    name: "EmployeePayroll",
    data() {
        return {
            month: null,
            months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            employeeJoins: 0,
            employeeExits: 0,
        }
    },
    methods: {

    }
}
</script>

<style lang="scss" scoped>
.title{
  padding: 20px;
}
.empDetails {
    display: flex;
    justify-content: center;

    span {
        font-size: 16px;
        color: #606060;
        margin-right: 50px;
        margin-top: 15px;
    }
}
.overlay {
  position: relative;
}

.top-text {
  position: absolute;
  background-color: rgba(255, 255, 255, 0.8);
  width: 100%;
  height: 100%;
  z-index: 1;
}
.wip-text {
  font-family: Montserrat;
  font-size: 32px;
  font-weight: 600;
  text-align: center;
  color: #444444;
  margin-top: 30%;
  transform: rotate(-45deg);
}
.employee {
  position: relative;
}
</style>
